import { cn } from 'lib/utils';

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  center = true,
  light = false,
  className,
}) {
  return (
    <div className={cn('mb-8 sm:mb-12 md:mb-16', center && 'text-center', className)}>
      {eyebrow && (
        <p
          className={cn(
            'text-[11px] sm:text-xs md:text-sm font-body font-semibold tracking-[0.18em] sm:tracking-[0.2em] uppercase mb-3 sm:mb-4',
            light ? 'text-Mora-caramel' : 'text-Mora-caramel'
          )}
        >
          {eyebrow}
        </p>
      )}

      <h2
        className={cn(
          'font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-tight',
          light ? 'text-Mora-cream' : 'text-Mora-dark'
        )}
      >
        {title}
      </h2>

      {/* Decorative Line */}
      <div
        className={cn(
          'mt-4 sm:mt-6 h-[2px] w-12 sm:w-16 rounded-full',
          center && 'mx-auto',
          light
            ? 'bg-gradient-to-r from-Mora-caramel to-Mora-gold'
            : 'bg-gradient-to-r from-Mora-brown to-Mora-caramel'
        )}
      />

      {subtitle && (
        <p
          className={cn(
            'mt-4 sm:mt-6 max-w-2xl text-sm sm:text-base md:text-lg leading-relaxed font-body',
            center && 'mx-auto',
            light ? 'text-Mora-beige/90' : 'text-Mora-brown/70'
          )}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}
